function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.608 9.625c-2.186 1.51-3.642 4.162-3.642 7.178 0 3.028 1.47 5.672 3.67 7.179h8.355c2.199-1.507 3.669-4.15 3.669-7.179 0-3.016-1.456-5.669-3.642-7.178z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 1.044
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.862 13.844c-.554 0-1 .446-1 1v1.875h2.5v-1.875c0-.554-.446-1-1-1z",
  strokeLinecap: "square",
  transform: "matrix(.95724 0 0 .95853 4.69 4.621)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.244 8.7l.023 3.774M26.144 8.7l.023 3.774",
  transform: "matrix(.95724 0 0 .95853 5.078 4.621)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.608 32.094c-2.186 1.51-3.642 4.162-3.642 7.178 0 3.028 1.47 5.672 3.67 7.179h8.355c2.199-1.507 3.669-4.151 3.669-7.179 0-3.016-1.456-5.669-3.642-7.178z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 1.044
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.862 13.844c-.554 0-1 .446-1 1v1.875h2.5v-1.875c0-.554-.446-1-1-1z",
  strokeLinecap: "square",
  transform: "matrix(.95724 0 0 .95853 4.69 26.611)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.244 8.7l.023 3.774M26.144 8.7l.023 3.774",
  transform: "matrix(.95724 0 0 .95853 5.078 26.611)"
}));

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.813,
  cy: 28.038,
  rx: 1.438,
  ry: 1.436,
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square",
  d: "M8.976 1.033h35.673v54.01H8.976z"
});

var SvgPoweroutlet = function SvgPoweroutlet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoweroutlet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Power outlet.d1b32643.svg";
export { ForwardRef as ReactComponent };